<template>
  <li class="main-table-cell main-table-cell-medium" :style="{width: width}">
    <div class="main-table-cell-wrap">
      <span class="main-table-txt link-normal">
        <slot></slot>
      </span>
    </div>
  </li>
</template>
<script>
  export default {
    name: 'grid-table-td',
    props: {
      width: {
        type: String,
        default: '160px'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/grid-menu/grid-table-td.vue